import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
    <p
        className={`text-[11px] font-semibold uppercase tracking-[0.28em] ${
            dark ? "text-gold" : "text-teak"
        }`}
    >
        {children}
    </p>
);
